const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS'
const SET_DASHBOARD_IS_VIEW_ALL = 'SET_DASHBOARD_IS_VIEW_ALL'
const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'
const RESET_DASHBOARD_STATE = 'RESET_DASHBOARD_STATE'

const initialState = {
  filters: null,
  isViewAll: false,
  dashboardData: null,
  cachedGroupId: null,
  cachedFilters: null,
  cachedIsViewAll: null,
}

export const setDashboardFilters = (filters, groupId) => ({
  type: SET_DASHBOARD_FILTERS,
  payload: { filters, groupId },
})

export const setDashboardIsViewAll = (isViewAll, groupId) => ({
  type: SET_DASHBOARD_IS_VIEW_ALL,
  payload: { isViewAll, groupId },
})

export const setDashboardData = (data, groupId, filters, isViewAll) => ({
  type: SET_DASHBOARD_DATA,
  payload: { data, groupId, filters, isViewAll },
})

export const resetDashboardState = () => ({
  type: RESET_DASHBOARD_STATE,
})

const dashBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_FILTERS: {
      return {
        ...state,
        filters: action.payload.filters,
        cachedGroupId: action.payload.groupId,
      }
    }
    case SET_DASHBOARD_IS_VIEW_ALL: {
      return {
        ...state,
        isViewAll: action.payload.isViewAll,
        cachedGroupId: action.payload.groupId,
      }
    }
    case SET_DASHBOARD_DATA: {
      return {
        ...state,
        dashboardData: action.payload.data,
        cachedGroupId: action.payload.groupId,
        cachedFilters: action.payload.filters,
        cachedIsViewAll: action.payload.isViewAll,
      }
    }
    case RESET_DASHBOARD_STATE: {
      return {
        ...state,
        filters: null,
        dashboardData: null,
        cachedGroupId: null,
        cachedFilters: null,
        cachedIsViewAll: null,
      }
    }
    default:
      return state
  }
}

export default dashBoardReducer
